// ═══════════════════════════════════════════════════════════════════════════════
//  src/interview/script.js
//  INTERVIEW ROOM — el guion, en piezas
//
//  Funciones puras, sin React. Viven aparte de PhoneticText.jsx por dos
//  razones: el fast refresh de Vite sólo funciona si un archivo exporta
//  únicamente componentes, y así se pueden probar sin montar nada.
// ═══════════════════════════════════════════════════════════════════════════════

/**
 * Parte el texto en frases.
 *
 * Corta tras `.`, `?` o `!` sólo cuando les sigue un espacio y una mayúscula:
 * así `Node.js` o `e.g.` no se parten por la mitad. Si una marca de fonética
 * (`~palabra|fo-né-ti-ca~`) quedara abierta al cortar, la frase se vuelve a
 * unir con la siguiente — antes que romper una marca, se prefiere una frase
 * larga.
 */
export function splitSentences(text) {
  const bruto = String(text || '')
    .trim()
    .split(/(?<=[.!?])\s+(?=[A-Z"'¿¡“‘])/g)
    .map(s => s.trim())
    .filter(Boolean);

  const out = [];
  for (const frase of bruto) {
    const abierta = out.length && (out[out.length - 1].match(/~/g) || []).length % 2 === 1;
    if (abierta) out[out.length - 1] += ' ' + frase;
    else out.push(frase);
  }
  return out.length ? out : [String(text || '')];
}

/** Trocea una frase en texto plano y palabras marcadas con su fonética. */
export function tokenize(frase) {
  return String(frase)
    .split(/(~[^|~]+\|[^~]+~)/g)
    .filter(p => p !== '')
    .map((p, i) => {
      if (p.startsWith('~') && p.endsWith('~') && p.includes('|')) {
        const [word, phonetic] = p.slice(1, -1).split('|');
        return { k: 'key', word, phonetic, i };
      }
      return { k: 'txt', text: p, i };
    });
}

/** Quita las marcas de fonética y deja el texto limpio. */
export function plain(frase) {
  return String(frase || '').replace(/~([^|~]+)\|[^~]+~/g, '$1');
}
